import { render, staticRenderFns } from "./chartsBar.vue?vue&type=template&id=3754ed83&scoped=true&"
import script from "./chartsBar.vue?vue&type=script&lang=js&"
export * from "./chartsBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3754ed83",
  null
  
)

export default component.exports